module.exports = __webpack_public_path__ + "img/公司实力.4a3d1bb1.jpg";